import { SchoolbookListingParameters } from '../constants/interfaces';
import { ApiResponse } from '../models/api/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '../constants/api';

@Injectable({
  providedIn: 'root',
})
export class SchoolbookService {
  constructor(private http: HttpClient) {}

  getListing(p: SchoolbookListingParameters) {
    return this.http.get<ApiResponse<any>>(API.schoolbookListing(p), {
      withCredentials: true,
    });
  }
}
